import React, { useState } from 'react'
import profile from '../../assets/profile/profile.jpg'
import ham from '../../assets/icons/ham.png'
import './nav.css'

const Navbar = ({ scrollToSkills, scrollToHome, scrollToAbout, scrollToProjects }) => {

    const [toggleNav, setToggleNav] = useState(false)

    return (
        <div className='sticky top-0 left-0 w-full bg-gray-900 flex justify-between align-center' style={{ zIndex: "1", minHeight: "50px" }}>
            <div className='text-white font-normal p-2 my-1 mx-3'>
                <img src={profile} alt="Sai Charan" className='h-8 absolute top-2 mt-1 left-2' style={{ zIndex: '10' }} />
            </div>
            <div className='absolute top-3 right-1 hamicon'>
                <img src={ham} alt="" className='h-7' onClick={() => setToggleNav(!toggleNav)} style={{ zIndex: '2' }} />
            </div>
            {toggleNav &&
                <div className="flex p-2 text-white lg:w-1/4 justify-between baloo font-normal navLinks" style={{ fontSize: "1rem" }}>
                    <p className='mx-2 cursor-pointer rounded p-1 my-1 hover:bg-gray-600' onClick={() => scrollToHome()}>Home</p>
                    <p className='mx-2 cursor-pointer rounded p-1 my-1 hover:bg-gray-600' onClick={() => scrollToAbout()}>About</p>
                    <p className='mx-2 cursor-pointer rounded p-1 my-1 hover:bg-gray-600' onClick={() => scrollToSkills()}>Skills</p>
                    <p className='mx-2 cursor-pointer rounded p-1 my-1 hover:bg-gray-600' onClick={() => scrollToProjects()}>Project</p>
                </div>
            }
            <div className="flex p-2 text-white lg:w-1/4 justify-between baloo font-normal hideInSmall" style={{ fontSize: "1rem" }}>
                <p className='mx-2 cursor-pointer rounded p-1 my-1 hover:bg-gray-600' onClick={() => scrollToHome()}>Home</p>
                <p className='mx-2 cursor-pointer rounded p-1 my-1 hover:bg-gray-600' onClick={() => scrollToAbout()}>About</p>
                <p className='mx-2 cursor-pointer rounded p-1 my-1 hover:bg-gray-600' onClick={() => scrollToSkills()}>Skills</p>
                <p className='mx-2 cursor-pointer rounded p-1 my-1 hover:bg-gray-600' onClick={() => scrollToProjects()}>Project</p>
            </div>
        </div>
    )
}

export default Navbar
